import { gql } from "@apollo/client";

export const CREATE_AJUSTE_LIQUIDACION = gql`
    mutation createAjusteLiquidacion($input: CreateAjusteLiquidacionInput!) {
        createAjusteLiquidacion(input: $input) {
            idAjusteLiquidacion
            ajuste
            observacionAjuste
            idMotivoAjuste
        }
    }
`;